module.exports = __webpack_public_path__ + "static/media/2023.e74edcc2.png";